import ScreenItem from './ScreenItem'
import Spinner from '../layout/Spinner'
import PropTypes from 'prop-types'

const Screens = ({ screens, loading }) => {
  if (loading) {
    return <Spinner />
  }

  return (
    <div style={screenStyle}>
      {screens.map((screen) => (
        <ScreenItem key={screen.id} screen={screen} />
      ))}
    </div>
  )
}

Screens.propTypes = {
  screens: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
}

const screenStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridGap: '2rem 1rem',
  margin: '3px 0 3rem',
}

export default Screens
